(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1470],{

/***/ 89140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h_": function() { return /* binding */ HeaderBar; },
  "l8": function() { return /* binding */ HeaderBarLeftAction; },
  "so": function() { return /* binding */ HeaderBarRightAction; },
  "rF": function() { return /* binding */ HeaderBarTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/header-bar/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/header-bar/dist/index.esm.js



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".HeaderBar-module_headerBar__2SUZk{width:100%;min-width:300px;max-width:36rem;position:relative;display:flex;flex-direction:column;justify-content:space-between;box-sizing:border-box;box-shadow:0 2px 4px -4px var(--color-gray-90);color:var(--color-text-default);background-color:var(--color-white);z-index:11}@-webkit-keyframes HeaderBar-module_fadeIn__kGkba{0%{opacity:0}to{opacity:1}}@keyframes HeaderBar-module_fadeIn__kGkba{0%{opacity:0}to{opacity:1}}.HeaderBar-module_fadeInText__38d-Z .HeaderBar-module_headerBarTitle__yoIIa{-webkit-animation:HeaderBar-module_fadeIn__kGkba .15s linear;animation:HeaderBar-module_fadeIn__kGkba .15s linear}.HeaderBar-module_headerBarRow__VcBz3{display:flex;position:relative;box-sizing:border-box;width:100%;height:54px}.HeaderBar-module_headerBarSection__1DnWg{display:inline-flex;align-items:center;min-width:0}.HeaderBar-module_headerBarLeftSection__3e76J{flex-grow:1;flex-shrink:1;justify-content:flex-start;order:-1}.HeaderBar-module_headerBar__2SUZk.HeaderBar-module_large__njv5I .HeaderBar-module_headerBarLeftSection__3e76J{flex-wrap:wrap}.HeaderBar-module_headerBarRightSection__2C3Hw{flex-grow:1;flex-shrink:0;justify-content:flex-end;order:1}.HeaderBar-module_headerBar__2SUZk.HeaderBar-module_large__njv5I{height:94px}.HeaderBar-module_headerBar__2SUZk.HeaderBar-module_large__njv5I .HeaderBar-module_headerBarTitle__yoIIa{padding:0 1rem .75rem;width:100%}.HeaderBar-module_large__njv5I .HeaderBar-module_withSubtitle__1RTxK{transform:translateY(-8px)}.HeaderBar-module_headerBar__2SUZk.HeaderBar-module_large__njv5I .HeaderBar-module_headerBarRow__VcBz3{height:94px}.HeaderBar-module_headerBar__2SUZk.HeaderBar-module_large__njv5I .HeaderBar-module_action__1vOM6{height:auto;align-self:flex-start;padding-top:15px;padding-bottom:15px}.HeaderBar-module_transparent__6Pdpf{height:3.375rem;background-color:transparent}.HeaderBar-module_semi-transparent__2YXPn{height:3.375rem;background-color:rgba(47,48,49,.4)}.HeaderBar-module_borderless__3Z3is{box-shadow:none}.HeaderBar-module_fixed__2yyUZ{position:fixed;top:0}.HeaderBar-module_inverse__jXVwt{color:var(--color-text-inverse)}.HeaderBar-module_action__1vOM6{flex:0 0 0;line-height:.75rem;z-index:10;height:100%}.HeaderBar-module_icon__2e6Dy{color:var(--color-icon-subdued)}.HeaderBar-module_inverse__jXVwt .HeaderBar-module_icon__2e6Dy{color:var(--color-icon-inverse)}.HeaderBar-module_text__16Opz{font-weight:600;color:var(--color-interactive-default)}.HeaderBar-module_inverse__jXVwt .HeaderBar-module_text__16Opz{color:var(--color-text-inverse)}.HeaderBar-module_headerBarLeftAction__1ibWA{flex:0 1 1.5rem;padding-left:1rem;padding-right:1.25rem;text-align:left}.HeaderBar-module_headerBarLeftAction__1ibWA .HeaderBar-module_buttonLeftAction__2pTMr{padding:0;width:24px;height:100%;color:inherit;display:inline-flex;justify-content:center;align-items:center;background-color:transparent;border:none}.HeaderBar-module_buttonLeftAction__2pTMr:hover{cursor:pointer}.HeaderBar-module_headerBarTitle__yoIIa{flex-grow:1;flex-shrink:1;max-width:100%;text-align:left;overflow-x:hidden}.HeaderBar-module_headerBarTitleMainTitle__1qrZx{font-weight:600;font-size:var(--size-font-heading-sm);line-height:var(--size-line-height-text-heading-sm);transform:translateX(0);overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}.HeaderBar-module_headerBar__2SUZk.HeaderBar-module_large__njv5I .HeaderBar-module_headerBarTitleMainTitle__1qrZx{font-size:var(--size-font-heading-lg);min-height:1.5rem}.HeaderBar-module_headerBarTitleSubtitle__ejb17{font-weight:var(--font-weight-body-small);font-size:var(--size-font-body-small);line-height:var(--size-line-height-text-body-small);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.HeaderBar-module_headerBarRightAction__WaqlQ{padding-left:.75rem;padding-right:1rem;text-align:right;display:flex;align-items:center;justify-content:center;font-weight:var(--font-weight-action);font-size:var(--size-font-action);line-height:var(--size-line-height-text-action)}.HeaderBar-module_headerBarRightAction__WaqlQ svg{padding:.5rem}";
var styles = {"headerBar":"HeaderBar-module_headerBar__2SUZk","fadeInText":"HeaderBar-module_fadeInText__38d-Z","headerBarTitle":"HeaderBar-module_headerBarTitle__yoIIa","fadeIn":"HeaderBar-module_fadeIn__kGkba","headerBarRow":"HeaderBar-module_headerBarRow__VcBz3","headerBarSection":"HeaderBar-module_headerBarSection__1DnWg","headerBarLeftSection":"HeaderBar-module_headerBarLeftSection__3e76J","large":"HeaderBar-module_large__njv5I","headerBarRightSection":"HeaderBar-module_headerBarRightSection__2C3Hw","withSubtitle":"HeaderBar-module_withSubtitle__1RTxK","action":"HeaderBar-module_action__1vOM6","transparent":"HeaderBar-module_transparent__6Pdpf","semi-transparent":"HeaderBar-module_semi-transparent__2YXPn","borderless":"HeaderBar-module_borderless__3Z3is","fixed":"HeaderBar-module_fixed__2yyUZ","inverse":"HeaderBar-module_inverse__jXVwt","icon":"HeaderBar-module_icon__2e6Dy","text":"HeaderBar-module_text__16Opz","headerBarLeftAction":"HeaderBar-module_headerBarLeftAction__1ibWA","buttonLeftAction":"HeaderBar-module_buttonLeftAction__2pTMr","headerBarTitleMainTitle":"HeaderBar-module_headerBarTitleMainTitle__1qrZx","headerBarTitleSubtitle":"HeaderBar-module_headerBarTitleSubtitle__ejb17","headerBarRightAction":"HeaderBar-module_headerBarRightAction__WaqlQ","semiTransparent":"HeaderBar-module_semi-transparent__2YXPn"};
styleInject(css_248z);

var HeaderBarTitle = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.subtitle, subtitle = _b === void 0 ? '' : _b, props = __rest(_a, ["children", "className", "subtitle"]);
    return (react.createElement("div", __assign({ className: clsx_m(styles.headerBarTitle, typeof subtitle === 'string' && subtitle.length && styles.withSubtitle, className) }, props),
        react.createElement("div", { className: styles.headerBarTitleMainTitle }, children),
        typeof subtitle === 'string' && subtitle.length > 0 && (react.createElement("div", { className: styles.headerBarTitleSubtitle }, subtitle))));
};

var BackButton = function () { return (react.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.createElement("path", { d: "M19 12H5M5 12L11 18M5 12L11 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };
var HeaderBarLeftAction = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'icon' : _b; _a.children; var className = _a.className, onClick = _a.onClick, icon = _a.icon, props = __rest(_a, ["type", "children", "className", "onClick", "icon"]);
    return (react.createElement("div", __assign({ className: clsx_m(styles.action, styles.headerBarLeftAction, styles[type], className), onClick: onClick }, props),
        react.createElement("button", { "aria-label": "header-bar-left-action", className: clsx_m(styles.buttonLeftAction) }, icon ? react.createElement("span", null, icon) : react.createElement(BackButton, null))));
};

var HeaderBarRightAction = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'icon' : _b, children = _a.children, className = _a.className, props = __rest(_a, ["type", "children", "className"]);
    return (react.createElement("div", __assign({ className: clsx_m(styles.action, styles.headerBarRightAction, styles[type], className) }, props), react.Children.toArray(children).map(function (child, key) {
        if (typeof child === 'string') {
            return child;
        }
        return react.cloneElement(child, {
            style: {
                height: '100%',
                display: 'inline-flex',
                alignItems: 'center',
            },
            key: key,
        });
    })));
};

var HeaderBar = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.borderless, borderless = _c === void 0 ? false : _c, _d = _a.fixed, fixed = _d === void 0 ? false : _d, _e = _a.inverse, inverse = _e === void 0 ? false : _e, children = _a.children, className = _a.className, props = __rest(_a, ["variant", "borderless", "fixed", "inverse", "children", "className"]);
    var containerRef = react.useRef(null);
    var classes = clsx_m(styles.headerBar, styles[variant], borderless && styles.borderless, fixed && styles.fixed, inverse && styles.inverse, className);
    react.useEffect(function () {
        var _a;
        var containerClassList = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.classList;
        var timeout;
        var handleFadeIn = function (condition) {
            if (condition) {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    containerClassList.remove(styles.fadeInText);
                }, 150);
                containerClassList.add(styles.fadeInText);
            }
        };
        var handleScroll = function () {
            if (document.body.scrollTop > 120 ||
                document.documentElement.scrollTop > 120) {
                handleFadeIn(containerClassList.contains(styles[variant]));
                containerClassList.remove(styles[variant]);
            }
            else {
                handleFadeIn(!containerClassList.contains(styles[variant]));
                containerClassList.add(styles[variant]);
            }
        };
        if (variant === 'large' && fixed) {
            window.addEventListener('scroll', handleScroll);
        }
        return function () {
            if (variant === 'large' && fixed) {
                window.removeEventListener('scroll', handleScroll);
            }
        };
    }, [fixed, variant]);
    var arrayChildren = react.Children.toArray(children);
    var defaultChildren = arrayChildren.filter(function (child) { return child.type !== HeaderBarRightAction; });
    var righActionChildren = arrayChildren.filter(function (child) { return child.type === HeaderBarRightAction; });
    return (react.createElement("header", __assign({ className: classes, ref: containerRef }, props),
        react.createElement("div", { className: styles.headerBarRow },
            react.createElement("section", { className: clsx_m(styles.headerBarSection, styles.headerBarLeftSection) }, defaultChildren),
            react.createElement("section", { className: clsx_m(styles.headerBarSection, styles.headerBarRightSection) }, righActionChildren))));
};




/***/ }),

/***/ 14184:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/contextualized-learning/[contextualizedPageId]",
      function () {
        return __webpack_require__(82831);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84494);






var Anchor = function(props) {
    var href = props.href, children = props.children, linkProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "href",
        "children"
    ]);
    var androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var isAndroid = androidHandler.enabled;
    if (isAndroid) {
        // if children tag is anchor tag, return it
        if (children && typeof children === "object") {
            var child = children;
            if (child.type === "a") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: children
                });
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        href: href
    }, linkProps), {
        children: children
    }));
};


/***/ }),

/***/ 82831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _contextualizedPageId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./node_modules/@wartek-id/header-bar/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89140);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/hooks/useShowSocialDrawer.tsx
var useShowSocialDrawer = __webpack_require__(40932);
// EXTERNAL MODULE: ./components/ErrorBoundary/index.tsx + 2 modules
var ErrorBoundary = __webpack_require__(71130);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./api/microlearning/useAPIContextualizedLearning.ts
var useAPIContextualizedLearning = __webpack_require__(97493);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/CLRenderer.tsx + 17 modules
var CLRenderer = __webpack_require__(31395);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/CLStandalone.tsx







var CLStandalone = function(param) {
    var onPageLoaded = param.onPageLoaded;
    var ref;
    var query = (0,next_router.useRouter)().query;
    var clItem = (ref = (0,useAPIContextualizedLearning/* useGetCLItem */.r)(Number(query === null || query === void 0 ? void 0 : query.contextualizedPageId)).data) === null || ref === void 0 ? void 0 : ref.data;
    (0,react.useEffect)(function() {
        if (!!(clItem === null || clItem === void 0 ? void 0 : clItem.id)) {
            (0,googleAnalytics/* GATrackEvent */.l)({
                eventName: "contextualized_learning",
                eventParams: {
                    event_trigger: "open_kb_page",
                    action_type: "view_kb_page",
                    meta: JSON.stringify({
                        title: clItem === null || clItem === void 0 ? void 0 : clItem.title,
                        kb_id: clItem === null || clItem === void 0 ? void 0 : clItem.id
                    })
                },
                sendDefaultParams: true
            });
            onPageLoaded === null || onPageLoaded === void 0 ? void 0 : onPageLoaded(clItem === null || clItem === void 0 ? void 0 : clItem.title);
        }
    }, [
        onPageLoaded,
        clItem === null || clItem === void 0 ? void 0 : clItem.title,
        clItem === null || clItem === void 0 ? void 0 : clItem.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Pelatihan Mandiri | ",
                        clItem === null || clItem === void 0 ? void 0 : clItem.title
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative bg-gray-10 z-0",
                style: {
                    minHeight: "calc(100vh - 3.5rem)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CLRenderer/* default */.Z, {
                        clItem: clItem,
                        trackerWidgetData: {
                            source: "kb_page",
                            kbPageId: clItem === null || clItem === void 0 ? void 0 : clItem.id
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var pages_CLStandalone = (CLStandalone);

;// CONCATENATED MODULE: ./pages/pelatihan-mandiri/contextualized-learning/[contextualizedPageId]/index.tsx










var ContextualizedLearningPage = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), shareText = ref[0], setShareText = ref[1];
    var ref1 = (0,useShowSocialDrawer/* default */.Z)({
        drawerTitle: "Bagikan Referensi",
        shareText: shareText
    }), triggerShareDialog = ref1.triggerShareDialog, Drawer = ref1.Drawer;
    var handlePageLoaded = (0,react.useCallback)(function(title) {
        setShareText("Ibu/Bapak Guru, ada ".concat(!!title ? 'artikel "'.concat(title, '"') : "artikel", " di platform Merdeka Mengajar untuk jadi referensi. Silakan cek di tautan berikut: ").concat(window.location.href));
    }, [
        setShareText
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_error_boundary_umd.ErrorBoundary, {
        resetKeys: [
            router.asPath
        ],
        FallbackComponent: function(param) {
            var error = param.error, resetErrorBoundary = param.resetErrorBoundary;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* CustomErrorFallback */.m, {
                error: error,
                resetErrorBoundary: resetErrorBoundary
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HeaderBar */.h_, {
                fixed: true,
                borderless: true,
                className: "z-10 !shadow-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarLeftAction */.l8, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            as: "i",
                            color: "default",
                            children: "arrow_back"
                        }),
                        onClick: function() {
                            return dist_history/* backToApp */.NU(router.back);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarRightAction */.so, {
                        onClick: triggerShareDialog,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            children: "share"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_CLStandalone, {
                onPageLoaded: handlePageLoaded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer, {})
        ]
    });
};
ContextualizedLearningPage.layoutOpts = {
    hasHeader: false,
    className: "bg-gray-10 mt-14"
};
/* harmony default export */ var _contextualizedPageId_ = (ContextualizedLearningPage);


/***/ }),

/***/ 1413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sz": function() { return /* binding */ getTimestampForGTag; },
  "ps": function() { return /* binding */ minuteToHour; },
  "Sy": function() { return /* binding */ timeAgo; }
});

// UNUSED EXPORTS: formatDate, humanizeDate, isoStringToDateInputTypeFormat, locale, months, youtubeDurationToHms, youtubeDurationToSeconds

// EXTERNAL MODULE: ./node_modules/timeago.js/esm/index.js + 6 modules
var esm = __webpack_require__(52165);
;// CONCATENATED MODULE: ./utils/number.ts
function roundWithPrecision(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
var random = function(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
};
/**
 * Transforms a number into human-readable format with delimiters every three digits
 * @param {number} number     Number to be transformed
 * @param {string} delimiter  Delimiter character, choose between dots or commas
 *
 * @returns {string} Human-readable number representation with delimiters
 */ function delimit(number) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".";
    var rgx = /\B(?=(\d{3})+(?!\d))/g;
    var result = "";
    var integerPart = Math.trunc(number);
    var decimalPart = parseFloat((number % 1).toFixed(2));
    var decimalDelimiter = delimiter === "." ? "," : ".";
    result = result + integerPart.toString().replace(rgx, delimiter);
    if (decimalPart) result = result + decimalDelimiter + decimalPart.toString().split(".")[1];
    return result;
}
/**
 * Helper function to render a number in a human-readable format
 * @param {number} num Number to be rendered
 * @param {number} decimals Trailing decimal places to be rendered
 * @param {number} step Multiplier between notations
 * @param {string[]} notations List of notations for the rendered string
 * @returns {string} Human-readable number with notation
 */ function humanizeNumber(num) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000, notations = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], separator = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (num === 0) return "0" + (notations.length > 0 ? " ".concat(notations[0]) : "");
    var dm = decimals < 0 ? 0 : decimals;
    var i = Math.floor(Math.log(Math.abs(num)) / Math.log(step));
    return (delimit(parseFloat((num / Math.pow(step, i)).toFixed(dm))) + separator + notations[i]).trim();
}
/**
 * Formats bytes into most-appropriate decimal notation.
 *
 * @param {number} bytes    Number of bytes
 * @param {number} decimals Number of decimal places
 * @returns {string} Human-readable file size string
 *
 * @example
 * formatBytes(1248) // "1,2 KB"
 * formatBytes(1248, 2) // "1,25 KB"
 * formatBytes(1248, 2, '.') // 1.25 KB
 */ function formatBytes(bytes) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var sizes = [
        "Byte",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    return humanizeNumber(Math.abs(bytes), decimals, 1024, sizes, " ");
}

;// CONCATENATED MODULE: ./utils/datetime.ts




var locale = "id";
(0,esm/* register */.z2)(locale, function(_number, index, totalSec) {
    var translations = [
        [
            "baru saja",
            "sebentar"
        ],
        [
            "%s detik lalu",
            "dalam %s detik"
        ],
        [
            "1 menit lalu",
            "dalam 1 menit"
        ],
        [
            "%s menit lalu",
            "dalam %s menit"
        ],
        [
            "1 jam lalu",
            "dalam 1 jam"
        ],
        [
            "%s jam lalu",
            "dalam %s jam"
        ],
        [
            "1 hari lalu",
            "dalam 1 hari"
        ],
        [
            "%s hari lalu",
            "dalam %s hari"
        ],
        [
            "1 minggu lalu",
            "dalam 1 minggu"
        ],
        [
            "%s minggu lalu",
            "dalam %s minggu"
        ],
        [
            "1 bulan lalu",
            "dalam 1 bulan"
        ],
        [
            "%s bulan lalu",
            "dalam %s bulan"
        ],
        [
            "1 tahun lalu",
            "dalam 1 tahun"
        ],
        [
            "%s tahun lalu",
            "dalam %s tahun"
        ], 
    ];
    var translation = translations[index];
    if (translation[0].includes("minggu")) {
        var dayInSec = 86400;
        var days = Math.ceil(totalSec / dayInSec);
        return [
            "".concat(days, " hari lalu"),
            "dalam ".concat(days, " hari")
        ];
    }
    return translation;
});
var months = (/* unused pure expression or super */ null && ([
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember", 
]));
function humanizeDate(timestamp) {
    var dateObj = new Date(timestamp);
    var date = dateObj.getDate();
    var month = dateObj.getMonth();
    var year = dateObj.getFullYear();
    var hour = dateObj.getHours() > 9 ? dateObj.getHours() : "0" + dateObj.getHours();
    var minute = dateObj.getMinutes() > 9 ? dateObj.getMinutes() : "0" + dateObj.getMinutes();
    return "".concat(date, " ").concat(months[month], " ").concat(year, ", ").concat(hour, ":").concat(minute);
}
function youtubeDurationToSeconds(duration) {
    // https://developers.google.com/youtube/v3/docs/videos#contentDetails.duration
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    duration = duration.replace("PT", "");
    if (duration.indexOf("H") > -1) {
        var hoursSplit = duration.split("H");
        hours = parseInt(hoursSplit[0]);
        duration = hoursSplit[1];
    }
    if (duration.indexOf("M") > -1) {
        var minutesSplit = duration.split("M");
        minutes = parseInt(minutesSplit[0]);
        duration = minutesSplit[1];
    }
    if (duration.indexOf("S") > -1) {
        var secondsSplit = duration.split("S");
        seconds = parseInt(secondsSplit[0]);
    }
    return hours * 3600 + minutes * 60 + seconds;
}
function youtubeDurationToHms(duration) {
    var durationInSeconds = youtubeDurationToSeconds(duration);
    var hours = Math.floor(durationInSeconds / 3600);
    var minutes = Math.floor(durationInSeconds % 3600 / 60);
    var seconds = Math.floor(durationInSeconds % 3600 % 60);
    var hoursDisplay = hours > 0 ? String(hours).padStart(2, "0") + ":" : "";
    var minutesDisplay = String(minutes).padStart(2, "0") + ":";
    var secondsDisplay = String(seconds).padStart(2, "0");
    return hoursDisplay + minutesDisplay + secondsDisplay;
}
function timeAgo(datetime) {
    return (0,esm/* format */.WU)(datetime, locale);
}
function minuteToHour(minutes) {
    if (minutes < 60) {
        return "".concat(minutes, " menit");
    }
    return "".concat(roundWithPrecision(minutes / 60, 1), " jam");
}
function isoStringToDateInputTypeFormat(isoDateString) {
    var date = new Date(isoDateString);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    var sday = dt.toString();
    var smonth = month.toString();
    if (dt < 10) {
        sday = "0" + dt.toString();
    }
    if (month < 10) {
        smonth = "0" + month.toString();
    }
    return year.toString() + "-" + smonth + "-" + sday;
}
function getTimestampForGTag() {
    var date = new Date();
    date = new Date(date.getTime() - 3000000);
    return date.getFullYear().toString() + "-" + ((date.getMonth() + 1).toString().length == 2 ? (date.getMonth() + 1).toString() : "0" + (date.getMonth() + 1).toString()) + "-" + (date.getDate().toString().length == 2 ? date.getDate().toString() : "0" + date.getDate().toString()) + " " + (date.getHours().toString().length == 2 ? date.getHours().toString() : "0" + date.getHours().toString()) + ":" + ((date.getMinutes() / 5 * 5).toString().length == 2 ? (date.getMinutes() / 5 * 5).toString() : "0" + (date.getMinutes() / 5 * 5).toString()) + ":00";
}
function formatDate(datetime) {
    var formatString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dd MMMM yyyy";
    return formatFns(new Date(datetime), formatString, {
        locale: id
    });
}


/***/ }),

/***/ 7379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ GATrackEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var configs_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32178);
/* harmony import */ var utils_datetime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1413);



var getDefaultTrackerData = function() {
    var ref;
    var pathname = window.location.pathname;
    var userData = !!localStorage.getItem("app-login") ? JSON.parse(localStorage.getItem("app-login")) : false;
    var userId = localStorage.getItem(configs_auth__WEBPACK_IMPORTED_MODULE_0__/* .USER_ID_STORAGE_KEY */ .dV);
    var ref1;
    return {
        userId: !!userId && userId !== "null" ? userId : (ref1 = userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "null",
        timestamp: (0,utils_datetime__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampForGTag */ .Sz)(),
        product: pathname.split("/")[1].replace("-", "_")
    };
};
var GATrackEvent = function(param) {
    var eventName = param.eventName, eventParams = param.eventParams, _sendDefaultParams = param.sendDefaultParams, sendDefaultParams = _sendDefaultParams === void 0 ? false : _sendDefaultParams;
    if (typeof gtag !== "undefined") {
        if (!!eventParams && !!eventParams["meta"] && typeof eventParams["meta"] === "object") {
            eventParams["meta"] = JSON.stringify(eventParams["meta"]);
        }
        gtag("event", eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sendDefaultParams && getDefaultTrackerData(), eventParams));
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,1958,5370,4088,8703,9961,9595,1529,586,9158,9774,2888,179], function() { return __webpack_exec__(14184); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);